import React from 'react';
import Background from '../components/Background';
import ContactSection from '../components/ContactSection';

const ContactPage = () => {
  return (
    <>
      <Background />
      <div className="page">
        <ContactSection />
      </div>
    </>
  );
};

export default ContactPage;
